// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Flex, Heading } from '@locus-taxy/neo-ui';

import JsonView from 'platform/settings/form/JsonView';

import { viewControlRenderers } from './controls';
import { viewLayoutRenderers } from './layouts';

import type { ObjectProperties, ObjectArrayMetadata } from './types';

type Props = {
    properties: ObjectProperties,
    i18n: $FixMe,
    metadata: ObjectArrayMetadata,
    onEdit: (item: ObjectProperties) => void
};

const renderers = [...viewLayoutRenderers, ...viewControlRenderers];

const ObjectPropertiesView = ({
    properties,
    i18n,
    metadata,
    onEdit
}: Props): React.Node => {
    const { t } = useTranslation('platform');

    const { options } = metadata.view || {};
    const title = options?.titleKey ? properties[options.titleKey] : '';
    const value = { item: properties };

    const handleEdit = () => {
        onEdit(properties);
    };

    return (
        <Box boxShadow="active" backgroundColor="grey.100" borderRadius="4px">
            {/* Card header */}
            <Flex
                backgroundColor="white"
                borderTopRightRadius="4px"
                borderTopLeftRadius="4px"
                px={5}
                py={3}
                justifyContent="space-between"
                alignItems="center"
                boxShadow="inset 0px -1px 0px #E7E9EE"
            >
                <Flex>
                    <Heading color="grey.900" size="medium">
                        {title}
                    </Heading>
                </Flex>

                <Button palette="primary" onClick={handleEdit}>
                    {t('translations:edit')}
                </Button>
            </Flex>

            {/* Card content is rendered through JsonView from metadata */}
            <JsonView
                i18n={i18n}
                metadata={metadata.view}
                renderers={renderers}
                value={value}
            />
        </Box>
    );
};

export default ObjectPropertiesView;
